export const ShoppingCart = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    aria-hidden={true}
    height="82"
    viewBox="0 0 82 82"
    fill="none"
  >
    <path
      d="M40.2959 16.1673L28.7035 12.6487C26.0863 11.8557 23.3429 13.4063 22.5748 16.1128L20.5 23.4291M60.0357 23.4291L50.1559 13.2107C48.2269 11.2162 45.0999 11.2162 43.1709 13.2107L33.2911 23.4291H60.0357Z"
      stroke="#228800"
      strokeWidth="3.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.2665 61.5006H51.9368C53.9773 61.5008 55.7203 60.0408 56.0618 58.0454L63.4165 15.1672C63.7592 13.1729 65.5019 11.7144 67.5415 11.7148L70.286 11.7148M57.6041 49.0521H23.9374C20.0987 49.0516 16.7527 46.4605 15.8212 42.7669L12.2273 25.8444C11.9631 24.6004 12.9119 23.429 14.1837 23.429H61.8742M28.8675 67.3577C29.6762 67.3577 30.3318 68.0132 30.3318 68.8219C30.3318 69.6306 29.6762 70.2862 28.8675 70.2862C28.0588 70.2862 27.4032 69.6306 27.4032 68.8219C27.4032 68.0132 28.0588 67.3577 28.8675 67.3577ZM49.7859 67.3577C50.5947 67.3577 51.2502 68.0132 51.2502 68.8219C51.2502 69.6306 50.5947 70.2862 49.7859 70.2862C48.9772 70.2862 48.3217 69.6306 48.3217 68.8219C48.3217 68.0132 48.9772 67.3577 49.7859 67.3577Z"
      stroke="black"
      strokeWidth="3.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
